module.exports = __webpack_public_path__ + "static/media/Arrow-down-light-blue.5cbf4426.svg";